module.exports = (__webpack_require__(67))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor
// module id = 33
// module chunks = 39